// Distancia en km entre dos puntos (misma cuenta que server/lib/zona.js)
export function distanciaKm(a, b) {
  const rad = (g) => g * Math.PI / 180;
  const h = Math.sin(rad(b.lat - a.lat) / 2) ** 2
    + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(rad(b.lng - a.lng) / 2) ** 2;
  return 6371 * 2 * Math.asin(Math.sqrt(h));
}
